<template>
  <th class="text-center" width="5%">
    <slot name="after" />
    {{ index + 1 }}.
    <slot name="before" />
  </th>
</template>

<script>
export default {
  name: 'WLpCell',
  props: {
    index: {
      type: Number,
      required: true
    }
  }
};
</script>
